import {
    useMutation,
    UseMutationOptions,
    UseMutationResult
} from '@tanstack/react-query';
import {AuthTokens} from '../../types';
import {useCreateAuthenticatedFetch} from '../useCreateAuthenticatedFetch';
import baseUrl from '../baseUrl';
import {handleResponse} from '../handleResponse';

// Switches the active company (internally "customer") for the current user.
// The server re-issues auth tokens scoped to the newly selected company.
const useSwitchCompany = (
    options?: UseMutationOptions<AuthTokens, Error, string>
): UseMutationResult<AuthTokens, Error, string> => {
    const authenticatedFetch = useCreateAuthenticatedFetch();

    return useMutation({
        mutationFn: async (customerId: string) => {
            const response = await authenticatedFetch(
                `${baseUrl}/api/auth/switch-company`,
                {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify({customerId})
                }
            );
            return handleResponse<AuthTokens>(response);
        },
        ...options
    });
};

export default useSwitchCompany;
